import React from 'react';
import { message } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from 'store/actions';
import BN from 'bn.js';
import './style.css';

export default function Claim() {
  const dispatch = useDispatch();
  const token = process.env.REACT_APP_TOKEN_ADDRESS;
  const address = useSelector(state => state.address);
  const tranche = useSelector(state => state.tranche);
  const airdrop = useSelector(state => state.airdrop);
 
  const tranches = useSelector(state => state.tranches);
  const proofs = useSelector(state => state.proofs);
  const balances = useSelector(state => state.balances);
  const claimableAmount = useSelector(state => state.claimableAmount);
// claim button code
  const claim = async () => {
    try {
      if (!address) {
        message.error('Please connect BEP20 wallet first. Ensure it matches the CyberFM app:');
        return;
      }
      if (claimableAmount === 0) {
        message.error('You have nothing to claim.');
        return;
      }

      dispatch(actions.setLoading(true));
      const result = await airdrop.methods
        .multiClaim(address, tranches, balances, proofs)
        .send({ from: address }); 
      if (result.status) {
        message.success('Receive earnings successfully');
        dispatch(actions.setClaimableAmount(0));
      }
      dispatch(actions.setLoading(false));
    } catch (err) {
      dispatch(actions.setLoading(false));
      if (err.code === 4001) {
        return;
      }
      message.error('Claim has failed');
    }

    
  };

  return (
  
    <div>
      
    <a  className='btn-icon wow fadeIn' href='#' onClick={() => claim()}>
      <strong  >Claim FMR: Earnings</strong>
    </a>
    <br/><br/>
    <a  className='btn-icon wow fadeIn' href='https://dlpro.freshdesk.com/support/solutions/articles/44002354922' target= "_blank">
      <strong  >Need Help?</strong>
    </a>

<audio autoPlay>
  <source src="https://play.adtonos.com/xtreme" type="audio/ogg" />
  <source src="https://play.adtonos.com/xtreme" type="audio/wav" />
  <source src="https://play.adtonos.com/xtreme" type="audio/mpeg" />
</audio>


    <ol className='add-token'>
      <li class="nostyle">Contract Address FMR: {token}</li>
      <br/><br/>
      <br/><br/>
      <br/><br/>
      <br/><br/>
      <br/><br/>
      <br/><br/>
      <br/><br/>
      <br/><br/>
      <br/><br/>
      <br/><br/>
    </ol>
    
  </div>
  );
}
